// The one screen every "soon" item in the sidebar opens (ticket 56). It says what
// the screen will cover and what it is waiting on, both read from adminNav.js, so a
// soon screen cannot be a bare "Coming soon" box. It does nothing, saves nothing and
// reads nothing, so it carries the NOT WIRED chip, as the design's Soon screen does.
//
// kind 'later'   : what it would manage does not exist yet (V2 and beyond).
// kind 'planned' : designed, and built by a later ticket.
export default function SoonScreen({ item, isMobile }) {
  const later = item.kind === 'later';
  return (
    <div style={{ padding: isMobile ? '20px 16px 70px' : '30px 36px 70px', fontFamily: 'var(--font-body)' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 20, flexWrap: 'wrap', marginBottom: 22 }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--font-size-h4)', fontWeight: 700, color: 'var(--neutral-800)', margin: 0 }}>{item.label}</h1>
          {item.sub && <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', margin: '5px 0 0', maxWidth: 780, lineHeight: 1.55 }}>{item.sub}</p>}
        </div>
        {item.when && (
          <span style={{ fontSize: 'var(--font-size-xs)', fontWeight: 700, padding: '3px 10px', borderRadius: 'var(--radius-md)', background: 'var(--brand-cream)', color: 'var(--neutral-600)' }}>{item.when}</span>
        )}
      </div>

      <div style={{ background: 'var(--brand-white)', border: '1px solid var(--brand-sand)', borderRadius: 14, padding: isMobile ? '18px 16px' : '24px 26px', maxWidth: 780 }}>
        <p style={{ fontSize: 'var(--font-size-md)', color: 'var(--neutral-500)', margin: '0 0 16px', lineHeight: 1.7 }}>
          <strong>This screen is empty on purpose.</strong>{' '}
          {later
            ? 'What it would manage does not exist in the database yet, so anything drawn here would be controls that write nowhere and numbers that were invented.'
            : 'It is designed and not built yet, so anything drawn here would be controls that write nowhere and numbers that were invented.'}{' '}
          Here is what it covers once it is real, and what it is waiting on.
        </p>
        <div style={{ display: 'flex', gap: 9, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
          <span style={{ fontSize: 'var(--font-size-tiny)', fontWeight: 700, letterSpacing: 0.5, padding: '2px 6px', borderRadius: 'var(--radius-md)', border: '1px solid var(--feedback-warning-border)', color: 'var(--feedback-warning-ink)' }}>NOT WIRED</span>
          <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--neutral-400)' }}>
            {later ? 'Nothing here is built. This is the shape it will take. Admin tools follow once the feature itself is locked.' : 'Nothing here is built. This is the shape it will take.'}
          </span>
        </div>

        <p style={{ fontSize: 'var(--font-size-tiny)', fontWeight: 700, color: 'var(--neutral-400)', textTransform: 'uppercase', letterSpacing: 0.8, margin: '0 0 10px' }}>What it will cover</p>
        {(item.what || []).map(([lead, text], i) => (
          <div key={i} style={{ display: 'flex', gap: 11, padding: '11px 0', borderTop: '1px solid var(--brand-cream)' }}>
            <span style={{ color: 'var(--brand-rust)', lineHeight: 1.6 }}>·</span>
            <div>
              <span style={{ fontSize: 'var(--font-size-base)', fontWeight: 700, color: 'var(--neutral-800)' }}>{lead}</span>
              <span style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', lineHeight: 1.65 }}> {text}</span>
            </div>
          </div>
        ))}

        {item.blocked && (
          <div style={{ marginTop: 18, padding: '12px 14px', background: 'var(--feedback-warning-bg)', border: '1px solid var(--feedback-warning-border)', borderRadius: 10 }}>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--feedback-warning-ink)', margin: 0, lineHeight: 1.65 }}><strong>Waiting on:</strong> {item.blocked}</p>
          </div>
        )}
      </div>
    </div>
  );
}
